import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';

import { ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { ChartModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { NoteAttachmentBufferModule } from '../note-attachment-buffer/note-attachment-buffer.module';
import { NoteAttachmentsModule } from '../note-attachments/note-attachment.module';
import { TemplateModule } from '../template/template.module';
import { ContactDialogComponent } from './contact-dialog.component';
import { TagInputModule } from 'ngx-chips';
import { ContactDialogOpenOptions } from './contact-dialog.model';
import { ContactTemplateComponent } from './contact-template/contact-template.component';
import { ContactInputComponent } from './contact-template/contact-input/contact-input.component';
import { ContactAddressComponent } from './contact-template/contact-address/contact-address.component';
import { ContactCombineDropdownInputComponent } from './contact-template/contact-combine-dropdown-input/contact-combine-dropdown-input.component';
import { ContactAreaComponent } from './contact-template/contact-area/contact-area.component';
import { ContactDateComponent } from './contact-template/contact-date/contact-date.component';
import { ContactJobFunctionComponent } from './contact-template/contact-job-function/contact-job-function.component';
import { ContactMedComponent } from './contact-template/contact-med/contact-med.component';
import { ContactDropdownComponent } from './contact-template/contact-dropdown/contact-dropdown.component';
import { ContactLabelComponent } from './contact-template/contact-label/contact-label.component';
import { ContactMsdComponent } from './contact-template/contact-msd/contact-msd.component';
import { ContactAliasComponent } from './contact-template/contact-alias/contact-alias.component';
import { ContactDividerComponent } from './contact-template/contact-divider/contact-divider.component';
import { ContactFormerEmploymentComponent } from './contact-template/contact-former-employment/contact-former-employment.component';
import { ContactCurrentEmploymentComponent } from './contact-template/contact-current-employment/contact-current-employment.component';
import { ContactDialogModuleNew } from '../contact-dialog-new/contact-dialog.module';
import { ContactNavigationBarComponent } from './contact-navigation-bar/contact-navigation-bar.component';
import { ContactSingleDropdownComponent } from './contact-template/contact-single-dropdown/contact-single-dropdown.component';
import { ContactMoreRelationshipComponent } from './contact-template/contact-more-relationship/contact-more-relationship.component';
import { TamDashboardMapTileModule } from '../tam-dashboard/tam-dashboard-map-tile/tam-dashboard-map-tile.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        // kendo
        ButtonsModule,
        ChartModule,
        DateInputsModule,
        DropDownButtonModule,
        DropDownsModule,
        InputsModule,
        PopupModule,
        TooltipModule,
        DialogsModule,
        TagInputModule,
        TemplateModule,
        NoteAttachmentsModule,
        NoteAttachmentBufferModule,
        ContactDialogModuleNew,
        TamDashboardMapTileModule,
    ],
    declarations: [
        ContactDialogComponent,
        ContactTemplateComponent,
        ContactInputComponent,
        ContactAddressComponent,
        ContactCombineDropdownInputComponent,
        ContactAreaComponent,
        ContactDateComponent,
        ContactJobFunctionComponent,
        ContactMedComponent,
        ContactDropdownComponent,
        ContactLabelComponent,
        ContactMsdComponent,
        ContactAliasComponent,
        ContactDividerComponent,
        ContactFormerEmploymentComponent,
        ContactCurrentEmploymentComponent,
        ContactMoreRelationshipComponent,
        ContactNavigationBarComponent,
        ContactSingleDropdownComponent,
    ],
    exports: [
        ContactDialogComponent,
    ],
    providers: [ContactDialogOpenOptions]
})
export class ContactDialogModule { }
